import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import { Dispatch } from 'redux';
import 'hammerjs';
// Components
import { GetString } from '../StringResourceManager';
import { getTopDeviceIssuesCountBySite } from '../../store/Devices/AssetStatesActions';
import OverviewWidgetChart from '../OverviewWidgetChart';
import { ChartSeriesInterface } from '../../Interfaces/Devices/ChartSeriesInterface';
import { AssetStateCountBySite } from '../../Interfaces/Assets/AssetStateCountBySite';
import { SeriesClickEvent } from '@progress/kendo-react-charts';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { saveAssetStatusesFilters } from '../../store/UserSettings/UserSettingsActions';
import { ASSET } from '../../utils/constants';
import { ChartColors } from './ChartColors';

export default function TopStoresWithDeviceIssues() {
  const [refresh, setRefresh] = useState<boolean>(true);

  const deviceIssuesCountBySite: AssetStateCountBySite[] = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.deviceIssuesCountBySite
  );

  const isFetchingDeviceIssuesCountBySite: boolean = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.isFetchingDeviceIssuesCountBySite
  );

  const [topXStoresWithDeviceIssues, setTopXStoresWithDeviceIssues] =
    React.useState<string[]>([]);

  const [
    topXStoresWithDeviceIssuesSeriesData,
    setTopXStoresWithDeviceIssuesSeriesData,
  ] = React.useState<ChartSeriesInterface[]>([]);
  const dispatch: Dispatch<any> = useDispatch();

  useEffect((): ReturnType<React.EffectCallback> => {
    if (refresh) {
      getTopDeviceIssuesCountBySite(dispatch, 5);
    }
    return (): void => {};
  }, [refresh]);

  useEffect((): ReturnType<React.EffectCallback> => {
    const timeoutId: any = setTimeout(() => {
      setRefresh(false);
    }, 5000);

    return (): void => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect((): ReturnType<React.EffectCallback> => {
    processTopXStoreWithIssuesChartData();
  }, [deviceIssuesCountBySite]);

  const processTopXStoreWithIssuesChartData = () => {
    let storeList: string[] = [];
    let seriesData: ChartSeriesInterface[] = [
      {
        status: undefined,
        count: [],
        color: ChartColors.Red,
      },
    ];

    for (let i = 0; i < deviceIssuesCountBySite.length; ++i) {
      if (deviceIssuesCountBySite[i].Count == 0) continue;

      storeList.push(deviceIssuesCountBySite[i].SiteNumber.toString());
      seriesData[0].count.push(deviceIssuesCountBySite[i].Count);
    }

    setTopXStoresWithDeviceIssues(storeList);
    setTopXStoresWithDeviceIssuesSeriesData(seriesData);
  };

  const maxChartValueAxisItem: any = () => {
    return topXStoresWithDeviceIssuesSeriesData.length > 0
      ? Math.max(...topXStoresWithDeviceIssuesSeriesData[0].count) + 10
      : 10;
  };

  const onStoreNumberSeriesItemClick = (event: SeriesClickEvent) => {
    let filter: CompositeFilterDescriptor = {
      logic: 'and',
      filters: [
        {
          field: ASSET.FIELD_STORE_NAME,
          operator: 'eq',
          value: event.category,
        },
      ],
    };

    saveAssetStatusesFilters(dispatch, filter);
  };

  return (
    <OverviewWidgetChart
      chartTitleText={GetString('TOP_STORES_WITH_DEVICE_ISSUES')}
      chartValueAxisItemtitle={GetString('NUMBER_OF_DEVICE_ISSUES')}
      chartCategoryAxisItem={topXStoresWithDeviceIssues}
      maxChartValueAxisItem={maxChartValueAxisItem()}
      seriesData={topXStoresWithDeviceIssuesSeriesData}
      chartSeriesClick={onStoreNumberSeriesItemClick}
      goToScreen="devices"
      chartType="bar"
      isRefreshing={isFetchingDeviceIssuesCountBySite}
    />
  );
}
